import { useState, useEffect, useRef } from 'react';
import { loadLeaflet } from './MapPickerModal';

const API_BASE_MAP = '/api/travel';

export default function TravelMapView({ onOpenListing }) {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_BASE_MAP}/map/`)
      .then((r) => r.json())
      .then((d) => setListings(d.listings || []))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    let cancelled = false;
    loadLeaflet().then(() => {
      if (cancelled || !mapRef.current) return;
      const L = window.L;

      if (mapInstanceRef.current) {
        mapInstanceRef.current.remove();
      }

      const center = listings.length > 0 ? [listings[0].latitude, listings[0].longitude] : [30.3753, 69.3451];
      const map = L.map(mapRef.current).setView(center, listings.length > 0 ? 6 : 5);
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; OpenStreetMap contributors',
      }).addTo(map);

      listings.forEach((l) => {
        const marker = L.marker([l.latitude, l.longitude]).addTo(map);
        const popupHtml = `
          <div style="text-align:center; min-width: 140px;">
            ${l.cover_image ? `<img src="${l.cover_image}" style="width:100%;height:80px;object-fit:cover;border-radius:6px;margin-bottom:6px;" />` : ''}
            <b>${l.title}</b><br/>
            <span style="color:#5F5E5A;font-size:12px;">${l.city}</span><br/>
            <span style="color:#0F6E56;font-weight:600;">${l.price_per_night_pi} Pi/night</span><br/>
            <button id="view-listing-${l.id}" style="margin-top:6px;padding:4px 12px;font-size:12px;border:none;border-radius:6px;background:#0F6E56;color:#fff;cursor:pointer;">View</button>
          </div>
        `;
        marker.bindPopup(popupHtml);
        marker.on('popupopen', () => {
          const btn = document.getElementById(`view-listing-${l.id}`);
          if (btn) btn.onclick = () => onOpenListing(l.slug);
        });
      });

      mapInstanceRef.current = map;
    });

    return () => {
      cancelled = true;
      if (mapInstanceRef.current) {
        mapInstanceRef.current.remove();
        mapInstanceRef.current = null;
      }
    };
  }, [listings]); // eslint-disable-line

  return (
    <div>
      {loading && <p style={{ textAlign: 'center', color: '#999', padding: '1rem' }}>Loading map...</p>}
      {!loading && listings.length === 0 && (
        <p style={{ textAlign: 'center', color: '#999', padding: '2rem 0' }}>
          No listings have a pinned location yet. Hosts can add one when creating or editing a listing.
        </p>
      )}
      <div ref={mapRef} style={{ width: '100%', height: 420, borderRadius: 12, background: '#eee' }} />
    </div>
  );
}
